import { useEffect } from 'react'

function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

// Per-page title + description. Google's crawler renders JS, so this
// genuinely helps organic search results. It does NOT fix social share
// previews (Facebook/Twitter/LinkedIn/iMessage link unfurls) -- those bots
// fetch the raw HTML and never run this hook, so they only ever see the
// static og:*/twitter:* tags baked into index.html regardless of which page
// was shared. That's an inherent limit of a client-rendered SPA with no
// server-side rendering, not something a hook can work around.
export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title
    setMeta('description', description)
  }, [title, description])
}
